import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import { tripsApi } from '../api';
import { TRIP_STATUS, TRIP_STATUS_BADGE } from '../utils/trips';

export default function MyTrips() {
  const navigate = useNavigate();
  const [trips, setTrips] = useState(null);

  useEffect(() => {
    tripsApi.mine().then((r) => setTrips(r.data)).catch(() => setTrips([]));
  }, []);

  if (trips === null) {
    return <div className="container" style={{ paddingTop: 48 }}><div className="spinner" /></div>;
  }

  return (
    <div>
      <AppHeader subtitle="Moje cesty" />
      <div className="container" style={{ paddingTop: 24, maxWidth: 640 }}>
        <p className="text-muted mb-16">Cesty, kde jsi přiřazený jako řidič. Otevři detail pro nakládku materiálu nebo předání na MU.</p>

        {trips.length === 0 ? (
          <div className="card text-center text-muted" style={{ padding: 32 }}>
            Zatím nejsi řidičem žádné cesty.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {trips.map((t) => (
              <div key={t.id} className="card" style={{ cursor: 'pointer', padding: 14 }}
                onClick={() => navigate(`/cesty/${t.id}`)}>
                <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: '1.05rem' }}>
                      🚚 {t.vehicle_name}{t.vehicle_plate ? ` · ${t.vehicle_plate}` : ''}
                    </div>
                    <div className="text-muted" style={{ fontSize: '0.85rem', marginTop: 2 }}>
                      {t.event_name ? `MU: ${t.event_name}` : 'Bez cílové MU'}
                      {t.unit_count > 1 ? ` · konvoj ${t.unit_count} vozidel` : ''}
                    </div>
                    {(t.origin || t.destination) && (
                      <div className="text-muted" style={{ fontSize: '0.82rem' }}>
                        {[t.origin, t.destination].filter(Boolean).join(' → ')}
                      </div>
                    )}
                  </div>
                  <span className={`badge ${TRIP_STATUS_BADGE[t.status]}`}>{TRIP_STATUS[t.status]}</span>
                </div>
                <div className="flex gap-8" style={{ marginTop: 10 }}>
                  <button className="btn btn-primary btn-sm flex-1" onClick={(e) => { e.stopPropagation(); navigate(`/cesty/${t.id}`); }}>
                    📦 Nakládka / detail
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-24">
          <button className="btn btn-outline btn-sm" onClick={() => navigate('/')}>← Zpět na rozcestník</button>
        </div>
      </div>
    </div>
  );
}
